import { SVGProps } from 'react';

export const AccountIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.33328 12.3334C6.33328 10.7992 7.29912 9.83341 8.83328 9.83341C10.3674 9.83341 11.3333 10.7992 11.3333 12.3334H6.33328ZM8.83327 5.66674C9.75327 5.66674 10.4999 6.4134 10.4999 7.3334C10.4999 8.2534 9.75327 9.00007 8.83327 9.00007C7.91327 9.00007 7.16661 8.2534 7.16661 7.3334C7.16661 6.4134 7.91327 5.66674 8.83327 5.66674ZM13.8333 0.666748H3.83333C2.91417 0.666748 2.16667 1.41341 2.16667 2.33341V3.16675H3.83333V4.00008H0.5V5.66675H2.16667V7.33342H3.83333V8.16675H0.5V9.83342H2.16667V11.5001H3.83333V12.3334H0.5V14.0001H2.16667V15.6667C2.16667 16.5859 2.91417 17.3334 3.83333 17.3334H13.8333C14.7525 17.3334 15.5 16.5859 15.5 15.6667V2.33341C15.5 1.41341 14.7525 0.666748 13.8333 0.666748Z"
        fill="currentColor"
      />
    </svg>
  );
};
